import React, { useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import iconMain from '../../../assets/logo.png';
import {
  handle_orderId,
} from '../../../Redux/reducer';

import {
  addSubscription
} from '../../../Redux/actions';

const App = () => {

    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const productDetails = useSelector((state) => state.auth.productDetails);
    const amountPayable = useSelector((state) => state.auth.amountPayable);
    const invoice = useSelector((state) => state.auth.invoice);
    
    // const orderId = useSelector((state) => state.auth.orderId);
    // const [txn_Token,setTxn_Token] = useState(null);
    const hostName_production = 'https://securegw.paytm.in' 
    const hostName_staging = 'https://securegw-stage.paytm.in';

    const enterMessageUsPressed = (event) => {
      var code = event.keyCode || event.which;
      if (code === 13) {
          handlePaymentSubmit(event);
        //13 is the enter keycode
        //Do stuff in here
      }
    };
    var https = require('https-browserify')
    //Payment Final Function
  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    makePayment()
  };

      function isDate(val) {
        // Cross realm comptatible
        return Object.prototype.toString.call(val) === '[object Date]'
      }
      
      function isObj(val) {
        return typeof val === 'object'
      }
      
      function stringifyValue(val) {
        if (isObj(val) && !isDate(val)) {
          return JSON.stringify(val)
        } else {
          return val
        }
      }
      
      function buildForm({ action, params }) {
        const form = document.createElement('form')
        form.setAttribute('method', 'post')
        form.setAttribute('action', action)
      
        // console.log("lohith:buildForm:action,params",action,params,performance.now());
        Object.keys(params).forEach(key => {
          // console.log("lohith:buildForm:key",key,performance.now());
          // console.log("lohith:buildForm:params[key]",params[key],performance.now());
          const input = document.createElement('input')
          input.setAttribute('type', 'hidden')
          input.setAttribute('name', key)
          input.setAttribute('value', stringifyValue(params[key]))
          form.appendChild(input)
        })
      
        return form
      }
      
      function post(details) {
        // console.log("lohith:post:details",details, performance.now());
        const form = buildForm(details)
        // console.log("lohith:post:form",performance.now());
        document.body.appendChild(form)
        form.submit()
        // console.log("lohith:post:form>submit",performance.now());
        form.remove()
        // console.log("lohith:post:form>remove",performance.now());
      }
  
      // const handleTransactionStatus=(data)=>
      // {
      //   console.log("lohith:handleTransactionStatus");
      //   return fetch(`http://localhost:5000/api/callback`,{
      //   // return fetch(`http://localhost:5000/api/payment`,{
      //     method:"POST",
      //       headers:{
      //           Accept:"application/json",
      //           "Content-Type":"application/json"
      //       },
      //       // body:JSON.stringify({...data,ORDER_ID:orderId})
      //       body:JSON.stringify(data)
      //   })
      //   // .then(response=>{
      //   //   console.log("lohith:handleTransactionStatus:post:data:",data,":response:",response)
      //   //   response.json()
      //   // })
      //   .then(response=>response.json())
      //   .catch(err=>console.log("lohith:handleTransactionStatus:post:err",err))
      // }

      // const handleProcessTransaction=(response)=>
      // {
      //   console.log("lohith:handleProcessTransaction");
      //   return fetch(`http://localhost:5000/api/process`,{
      //     method:"POST",
      //       headers:{
      //           Accept:"application/json",
      //           "Content-Type":"application/json"
      //       },
      //       body:JSON.stringify(response)
      //   })
      //   .then(response=>response.json())
      //   .catch(err=>console.log("lohith:handleProcessTransaction:post:err",err));
      // }

      // const handleFetchBinDetail=(response)=>
      // {
      //   console.log("lohith:handleFetchBinDetail");
      //   return fetch(`http://localhost:5000/api/fetchBin`,{
      //     method:"POST",
      //       headers:{
      //           Accept:"application/json",
      //           "Content-Type":"application/json"
      //       },
      //       body:JSON.stringify(response)
      //   })
      //   .then(response=>response.json())
      //   .catch(err=>console.log("lohith:handleFetchBinDetail:post:err",err));
      // }
      
     

    function readLocalOrServerFile(file, type, asyncFlag, callback)
          {
            console.debug("Lohith:FileUpload: readLocalOrServerFile start",
              file, type, asyncFlag, callback);

            var request = new XMLHttpRequest();

            request.responseType = type;

            request.open("GET", file, asyncFlag);

            request.send();

            request.onreadystatechange = function ()
              {
                  if(request.readyState === 4)
                  {
                      if(request.status === 200 || request.status == 0)
                      {
                  console.debug("Lohith:FileUpload: readLocalOrServerFile success",
                    request.responseText);

                  callback(request.responseText);
                      }
                  }
              }

          }
    
    function uploadDataToServer(host, port, fromFileContents, toFile) {
            //console.debug("Lohith:FileUpload:uploadDataToServer start", host, port, fromFileContents, toFile);

            var key, cert, ca;

            readLocalOrServerFile('/root/KEYS/privkey.pem', 'text', true,
              (keyData) => {

                key = keyData;

                readLocalOrServerFile('/root/KEYS/cert.pem', 'text', true,
                  (certData) => {

                    cert = certData;

                    readLocalOrServerFile('/root/KEYS/chain.pem', 'text', true,
                      (caData) => {

                        ca = caData;

                        const options = {
                          key,
                          cert,
                          ca: [ca],
                          //rejectUnauthorized: false
                        };
			console.log(https)
			console.log(https.get)
			console.log(https.Agent)
			console.log(options)
                //        var agent = new https.get(options);

                        var url = host + ':' + port + '/' + toFile;

                        //console.debug("Lohith:FileUpload:uploadDataToServer start fetch", url, options, fromFileContents);

                        fetch(url, {
                          method: 'POST',
                          //mode: 'no-cors',
                          body: fromFileContents,
                  //        agent
                        })
			.then(response => response.json())
                        //.then(response => response.text())
                        .then(data => {
                            console.log("lohith:FileUpload:uploadDataToServer:response",data);
                            return data 
                        })
			.catch(
                          error => {console.debug("Lohith:FileUpload:uploadDataToServer fetch error", error);}
                        );
                      }
                    );//end readLocalOrServerFile('certificates/ca-cert.pem', 'text', true,

                  }
                );//end readLocalOrServerFile('certificates/client-cert.pem', 'text', true,

              }
            );//end readLocalOrServerFile('certificates/client-key.pem', 'text', true,

          };

      const handleInitiateTransaction=(response)=>
      {
        console.log("lohith:handleInitiateTransaction:response = ",response);
	//return fetch(`http://localhost:5000/api/initiate`,{
        //return fetch(`https://www.airender.co.in:5000/api/initiate`,{
        //  method:"POST",
        //    headers:{
        //        Accept:"application/json",
        //        "Content-Type":"application/json"
        //    },
        //    body:JSON.stringify(response)
        //})
        //.then(response=>response.json())
        //.catch(err=>console.log("handleInitiateTransaction:post:err",err))
	
	var host = 'https://www.airender.co.in';
        var port = 5001;
        console.log("Lohith:FileUpload:user = ",user)
        //console.log("Lohith:file type = ",data.type)
        var toFile = "api/initiate"
        var resData = uploadDataToServer(host, port, response, toFile)
	console.log("Lohith:FileUpload:resData = ",resData)
	return resData
      }

      const handlePreInitialize=(data)=>
      {
        console.log("lohith:handlePreInitialize:data = ",data);
        //return fetch(`http://localhost:5000/api/preInitialize`,{
	//return fetch(`https://www.airender.co.in:5000/api/preInitialize`,{
        //  method:"POST",
        //    headers:{
        //        Accept:"application/json",
        //        "Content-Type":"application/json"
        //    },
        //    body:JSON.stringify(data)
        //})
        //.then(response=>response.json())
        //.catch(err=>console.log("handlePreInitialize:post:err",err))
	
	 var host = 'https://www.airender.co.in';
         var port = 5001;
	 console.log("Lohith:FileUpload:user = ",user)
         //console.log("Lohith:file type = ",data.type)
         //var toFile = "api/preInitialize"
	 var toFile = "api/preInitialize+"+data.amount+"%"+data.email+"%"+data.mobile
	 var resData = uploadDataToServer(host, port, data, toFile)
         console.log("Lohith:FileUpload:resData = ",resData)
         return resData

      }

    const makePayment=()=>
    {
      // console.log("lohith:makePayment:productDetails, user = ",productDetails, user);
      var data = {
        //amount: amountPayable.toString()+".00",
        amount: amountPayable+".00",
	email: user.email,
        mobile: user.mobile.slice(-10),
      }
      //handlePreInitialize(data).then(data => {
      //    console.log("lohith:makePayment:handlePreInitialize:response",data);
      //    var preInitializeResponse = data;
      //    dispatch(handle_orderId(preInitializeResponse.orderId));
      //    handleInitiateTransaction(preInitializeResponse).then(initializeResponse=>{
      //        loadCheckoutScript(
      //            preInitializeResponse.mid,
      //            preInitializeResponse.orderId,
      //            initializeResponse.body.txnToken,
      //            amountPayable.toString()+".00"
      //        );
      //    })
      //})
      if(true){
       var host = 'https://www.airender.co.in';
         var port = 5001;
         console.log("Lohith:FileUpload:user = ",user)
         //console.log("Lohith:file type = ",data.type)
         //var toFile = "api/preInitialize"
         var toFile = "api/preInitialize+"+data.amount+"%"+data.email+"%"+data.mobile
	 var key, cert, ca;

            readLocalOrServerFile('/root/KEYS/privkey.pem', 'text', true,
              (keyData) => {

                key = keyData;

                readLocalOrServerFile('/root/KEYS/cert.pem', 'text', true,
                  (certData) => {

                    cert = certData;

                    readLocalOrServerFile('/root/KEYS/chain.pem', 'text', true,
                      (caData) => {

                        ca = caData;

                        const options = {
                          key,
                          cert,
                          ca: [ca],
                          //rejectUnauthorized: false
                        };
                        console.log(https);
			console.log(https.agent) 
			console.log(options)      
                    //    var agent = new https.get(options);

                        var url = host + ':' + port + '/' + toFile;

                        console.debug("Lohith:FileUpload:uploadDataToServer start fetch", url, options,data);
			console.debug("Data",data)
			console.log("Options",options)

                        fetch(url, {
                          method: 'POST',
                          //mode: 'no-cors',
                          body: JSON.stringify(data),
                      //    agent
                        })
			//.then(response=>{
        		//  console.log("lohith:makePayment:handlePreInitialize:response",response,response.text(),response.json(),response.data);
			//  var preInitializeResponse = response.text()
      			//  dispatch(handle_orderId(preInitializeResponse.orderId));
      			//  handleInitiateTransaction(preInitializeResponse).then(initializeResponse=>{
      			//    loadCheckoutScript(
     			//      preInitializeResponse.mid, 
      			//      preInitializeResponse.orderId, 
      			//      initializeResponse.body.txnToken, 
      			//      amountPayable.toString()+".00"
      			//    );
      			//  })
      			//})
			.then(response => response.json())
			//.then(response => response.text())
  			.then(data => {
			    console.debug("lohith:makePayment:handlePreInitialize:response",data);
         		    var toFile2 = "api/initiate+"+data.orderId+"%"+data.txnAmountValue+"%"+data.custId+"%"+data.mobile+"%"+data.email
		
         		    var key, cert, ca;

            		    readLocalOrServerFile('/root/KEYS/privkey.pem', 'text', true,
              			(keyData) => {
                                    console.debug("Noel 1");

                		    key = keyData;

                		    readLocalOrServerFile('/root/KEYS/cert.pem', 'text', true,
                  			(certData) => {
							console.log("Noel 2")
                    			    cert = certData;

                    			    readLocalOrServerFile('/root/KEYS/chain.pem', 'text', true,
                      				(caData) => {
						console.log("Noel 3");
                        			    ca = caData;
                                                console.log("Noel 4")
                        			    const options = {
                        			      key,
                        			      cert,
                        			      ca: [ca],
                        			      //rejectUnauthorized: false
                        			    };

                        //			    var agent = new https.Agent(options);
							console.log("Noel 5")
							
						console.log(toFile2)
                        			    var url = host + ':' + port + '/' + toFile2;
							console.log("Noel 6",url)

 				                       			    //console.debug("Lohith:FileUpload:uploadDataToServer start fetch", url, options, fromFileContents);
							console.log(data)
                        			    fetch(url, {
                        			      method: 'POST',
                        			      //mode: 'no-cors',
                        			      body: JSON.stringify(data),
                        			     // agent
                        			    }).then(response => response.json())
                        			    //.then(response => response.text())
                        			    .then(data2 => {
                        			        console.log("lohith:makePayment:handleInitiate:response",data2);
							loadCheckoutScript(
                            				    data.mid,
                            				    data.orderId,
                            				    data2.body.txnToken,
                            				    amountPayable.toString()+".00"
                            				);
						    })
						    .catch(
                        			      error => {console.debug("Lohith:FileUpload:uploadDataToServer fetch error", error);}
                      				    );
                      				}
                    			    );//end readLocalOrServerFile('certificates/ca-cert.pem', 'text', true,

                  			}
                		    );//end readLocalOrServerFile('certificates/client-cert.pem', 'text', true,

              			}
            		    );//end readLocalOrServerFile('certificates/client-key.pem', 'text', true,



			    //var preInitializeResponse = data;
			    //dispatch(handle_orderId(preInitializeResponse.orderId));
                            //handleInitiateTransaction(preInitializeResponse).then(initializeResponse=>{
                            //    loadCheckoutScript(
                            //        preInitializeResponse.mid,
                            //        preInitializeResponse.orderId,
                            //        initializeResponse.body.txnToken,
                            //        amountPayable.toString()+".00"
                            //    );
                            //})

			})
			.catch(
                          error => {console.debug("Lohith:FileUpload:uploadDataToServer fetch error", error);}
                        );
                      }
                    );//end readLocalOrServerFile('certificates/ca-cert.pem', 'text', true,

                  }
                );//end readLocalOrServerFile('certificates/client-cert.pem', 'text', true,

              }
            );//end readLocalOrServerFile('certificates/client-key.pem', 'text', true,


    }}

    function getConfig(orderId,token,amount) {
      // console.log("lohith:getConfig:1");

      var config = {
        "root": "",
        "flow": "DEFAULT",
        "merchant": {
          "name": "aiRender Technology",
          "logo": iconMain,
        },
        "style": {
        //   "headerBackgroundColor": "#F9C31C",
          "headerColor": "#1C5DA7"
        },
        "data": {
          "orderId": orderId,
          "token": token,
          "tokenType": "TXN_TOKEN",
          "amount": amount,
        },
        "handler": {
          "notifyMerchant": function(eventName,data){
            // console.log("notifyMerchant handler function called");
            // console.log("eventName => ",eventName);
            // console.log("data => ",data);
            if(eventName == 'SESSION_EXPIRED'){
              alert("Your session has expired!!");
              window.location.reload();
            }
          },
          // "transactionStatus":function(response){
          //   console.log('lohith:getConfig:transactionStatus:response.STATUS: ', response.STATUS);
          //   if(response.STATUS === "TXN_SUCCESS"){
          //     console.log("transactionStatus => ",response);
          //     dispatch(addSubscription(user.email,invoice))
          //   }
          // },
        }
      };
      // console.log("lohith:onScriptLoad:1:config = ",config);
      return config;
    }

    const loadCheckoutScript = (mid,orderId,token,amount) => {
      
      // console.log("lohith:loadCheckoutScript:1");

      // const url = hostName_production+'/merchantpgpui/checkoutjs/merchants/';
      /* For Staging */
      // const url = 'https://securegw-stage.paytm.in/merchantpgpui/checkoutjs/merchants/';

      /* For Production */
      const url = 'https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/';

      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.src = url.concat(mid+".js");
      scriptElement.type = 'application/javascript';
      
      // console.log("lohith:loadCheckoutScript:scriptElement = ", scriptElement);
      
      scriptElement.onload = () => {
        // console.log("lohith:loadCheckoutScript:2");
        if (window && window.Paytm && window.Paytm.CheckoutJS) {
          // console.log("lohith:loadCheckoutScript:3");
          window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
            // console.log("lohith:loadCheckoutScript:4");
            // initialze configuration using init method
            var config = getConfig(orderId,token,amount);
            // console.log("lohith:loadCheckoutScript:4:config = ",config);
            window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
              // console.log("lohith:loadCheckoutScript:5");
              // after successfully updating configuration, invoke JS Checkout
              window.Paytm.CheckoutJS.invoke();
            }).catch(function onError(error){
              // console.log("lohith:loadCheckoutScript:6:error");
              console.log("loadCheckoutScript error => ",error);
            });
          });
        }
        else {
          console.error('Checkout instance not found!');
        }
      };
      scriptElement.onerror = error => {
        console.error('script load fail!');
      }
      document.body.appendChild(scriptElement);
    }

    return (
        <div>
            <button className='pay-btn' type={"submit"} onClick={makePayment}>Continue Payment</button>
        </div>
    )
}


export default App

